import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        snackbar: {
            active: false,
            text: 'My timeout is set to 2000.',
            timeout: 3000,
            success: false
        },
        user: {
            isLoggedIn:false,
            data:null
        }
    },
    mutations: {
        OPEN_SNACKBAR(state, payload) {
            state.snackbar.active = true
            state.snackbar.text = payload.msg
            state.snackbar.success = payload.success
        },
        CLOSE_SNACKBAR(state) {
            state.snackbar.active = false
        },
        SET_USER(state, response) {
            if(response != null){
                state.user = response
                state.user.isLoggedIn=true
            }else{
                state.user = {}
            }

        }
    },
        actions: {
        // Nueva acción para obtener el token CSRF
        async fetchCsrfCookie({ dispatch }) { // { dispatch } para llamar otras acciones si fuera necesario
            try {
                const axiosInstance = this._vm.$axios; // Accede a la instancia configurada en Vue.prototype (en axios.js)
                await axiosInstance.get('/sanctum/csrf-cookie');
                console.log('CSRF cookie obtained successfully.');
                return true;
            } catch (error) {
                console.error('Error obtaining CSRF cookie:', error);
                throw error; // Re-lanza el error para que sea capturado en main.js
            }
        },

        async getUser(){
            let respond = null;
            try {
                // Aseguramos que el CSRF cookie exista antes de intentar getUser
                await this.dispatch('fetchCsrfCookie'); // Llama a la nueva acción

                // Usamos la instancia global de axios que ya está configurada
                const response = await this._vm.$axios.post('getUser');
                console.log(response);
                this.commit("SET_USER", response.data);
                respond = true;
            } catch (error) {
                console.log('error', error);
                this.commit("SET_USER", null);
                respond = false;
                // La redirección se maneja en main.js
                throw error; // Re-lanza el error para que sea capturado en main.js
            }
            return respond;
        },
    },
    modules: {}
})